import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { ChartContainer, ChartConfig } from '@/components/ui/chart';

const chartConfig: ChartConfig = {
  delivered: { label: 'تم التوصيل', color: 'hsl(142, 72%, 42%)' },
  failed:    { label: 'فشل',        color: 'hsl(0, 84%, 60%)'   },
};

interface Props {
  data: { carrier_name: string; delivered: number; failed: number; success_rate: number }[];
}

export function CarrierPerformanceChart({ data }: Props) {
  if (!data.length) {
    return (
      <div className="flex items-center justify-center h-[220px] text-muted-foreground text-sm">
        لا توجد بيانات
      </div>
    );
  }

  return (
    <ChartContainer config={chartConfig} className="h-[220px] w-full">
      <BarChart data={data} margin={{ top: 4, right: 12, left: -16, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" className="stroke-border/40" />
        <XAxis dataKey="carrier_name" tick={{ fontSize: 10 }} />
        <YAxis tick={{ fontSize: 11 }} />
        <Tooltip
          contentStyle={{ background: 'hsl(var(--background))', border: '1px solid hsl(var(--border))', borderRadius: 8, fontSize: 12 }}
          formatter={(v: any, name: string) => [v, chartConfig[name]?.label ?? name]}
        />
        <Legend formatter={(name) => chartConfig[name]?.label ?? name} wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
        <Bar dataKey="delivered" fill="var(--color-delivered)" radius={[4, 4, 0, 0]} />
        <Bar dataKey="failed" fill="var(--color-failed)" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ChartContainer>
  );
}
